export const actions = {
    async obtener_unidades({ commit, dispatch, state }, data) {
        let f = {
            api: `unidades?filters[empresa][$eq]=${state.id_empresa_seleccionada}`
        }

        let r = await dispatch("obtener_data", f)
        commit('set_unidades', r)

    },
    async obtener_marcas({ commit, dispatch, state }, data) {
        let f = {
            api: `marcas?filters[empresa][$eq]=${state.id_empresa_seleccionada}`
        }

        let r = await dispatch("obtener_data", f)
        commit('set_marcas', r)

    },
    async obtener_proveedores({ commit, dispatch, state }) {
        let f = {
            api: `proveedores?filters[activo][$eq][0]=true&filters[empresa][$eq][1]=${state.id_empresa_seleccionada}`
        }

        let r = await dispatch("obtener_data", f)
        commit('set_proveedores', r)

    },
    async obtener_articulos({ commit, dispatch, state, getters }) {
        let p = {
            api: getters.ES_ROOT ? `articulos?filters[formula][$eq][0]=false&filters[empresa][$eq][1]=${state.id_empresa_seleccionada}&filters[activo][$eq][2]=true` : `articulos?filters[sucursal][$eq][0]=${state.datos_usuario.sucursal_asignada}&filters[formula][$eq][1]=false&filters[empresa][$eq][2]=${state.id_empresa_seleccionada}&filters[activo][$eq][3]=true`,
        }

        // let sucursal_ = data?.sucursal ?? state.datos_usuario.sucursal_asignada

        // SI ES ROOT ENTONCES SE QUITA EL FILTRO DE SUCURSAL, CASO CONTRARIO SE PONE EL FILTRO DE SUCURSAL

        let f = {
            api: getters.ES_ROOT ? `articulos?filters[formula][$eq][1]=true&filters[empresa][$eq][1]=${state.id_empresa_seleccionada}` : `articulos?filters[sucursal][$eq][0]=${state.datos_usuario.sucursal_asignada}&filters[formula][$eq][1]=true&filters[empresa][$eq][1]=${state.id_empresa_seleccionada}`
        }

        let productos = await dispatch("obtener_data", p)
        commit('set_productos', productos)

        let formulas = await dispatch("obtener_data", f)
        commit('set_formulas', formulas)

    },
    async obtener_materiales({ commit, dispatch, state }) {
        let f = {
            api: `materiales?filters[activo][$eq][0]=true&filters[empresa][$eq][1]=${state.id_empresa_seleccionada}`
        }

        let r = await dispatch("obtener_data", f)
        commit('set_materiales', r)

    },
    async obtener_maquinas({ commit, dispatch, state }) {
        let f = {
            api: `maquinas?filters[activo][$eq][0]=true&filters[empresa][$eq][1]=${state.id_empresa_seleccionada}`
        }

        let r = await dispatch("obtener_data", f)
        commit('set_maquinas', r)

    },
    async obtener_tipos_de_rollo({ commit, dispatch, state }) {
        let f = {
            api: `tipo-de-rollos?filters[activo][$eq][0]=true&filters[empresa][$eq][1]=${state.id_empresa_seleccionada}`
        }

        let r = await dispatch("obtener_data", f)
        commit('set_tipos_de_rollo', r)

    },
    async obtener_motivos_salidas({ state, commit, dispatch }) {
        let f = {
            api: `motivo-salidas?filters[empresa][$eq]=${state.id_empresa_seleccionada}`
        }

        let r = await dispatch("obtener_data", f)
        commit('set_motivos_salidas', r)
    },
    async obtener_vendedores({ state, commit, dispatch }) {
        let f = {
            api: `movimientos-detalles/c/vendedores?empresa=${state.id_empresa_seleccionada}&sucursal=${state.sucursal_seleccionada.codigo}`
        }

        let r = await dispatch("obtener_data", f)
        commit('set_vendedores', r)
    },
    async obtener_nombre_empresa_seleccion({ state, commit, dispatch }) {
        let f = {
            api: `empresas?filters[codigo][$eq]=${state.id_empresa_seleccionada}`
        }
        let r = await dispatch("obtener_data", f)
        commit('set_nombre_empresa_seleccionada', r[0].nombre)
    },
    async obtener_motivos_entradas({ state, commit, dispatch }) {
        let f = {
            api: `motivos-entradas?filters[empresa][$eq]=${state.id_empresa_seleccionada}`
        }

        let r = await dispatch("obtener_data", f)
        commit('set_motivos_entrada', r)
    }

}